import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { MeshGradient } from "@/components/effects/MeshGradient";
import { useMagnetic } from "@/hooks/use-magnetic";

const NotFound = () => {
  const location = useLocation();
  const ref = useMagnetic<HTMLAnchorElement>({ strength: 0.3, radius: 90 });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background">
      <MeshGradient variant="warm" />
      <div className="relative text-center">
        <p className="text-[11px] uppercase tracking-[0.22em] text-accent mb-4 font-medium">
          Error 404
        </p>
        <h1 className="font-display text-7xl md:text-8xl text-foreground leading-none">404</h1>
        <p className="mt-5 text-lg text-foreground/65">This page doesn't exist — or hasn't yet.</p>
        <a
          ref={ref}
          href="/"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground px-7 py-3.5 text-sm font-medium hover:opacity-90 transition will-change-transform"
        >
          Return home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
